import { render, staticRenderFns } from "./LeaveSummary.vue?vue&type=template&id=0225d40e&scoped=true"
import script from "./LeaveSummary.ts?vue&type=script&lang=ts&external"
export * from "./LeaveSummary.ts?vue&type=script&lang=ts&external"
import style0 from "./LeaveSummary.vue?vue&type=style&index=0&id=0225d40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0225d40e",
  null
  
)

export default component.exports